export default __webpack_public_path__ + "static/media/20210809_122745_3589.d2d67d94.jpg";